export default {
  name: "InfoCard",
  props: {
    title: String,
    content: String,
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    toggleInfo() {
      this.expanded = !this.expanded;
    },
  },
};
